import { render, staticRenderFns } from "./VelEdit.vue?vue&type=template&id=70661154&scoped=true&"
import script from "./VelEdit.vue?vue&type=script&lang=js&"
export * from "./VelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70661154",
  null
  
)

export default component.exports